import React from 'react'
import { ActionCreators as UndoActionCreators } from 'redux-undo'
import { connect } from 'react-redux'
import NavBarItem from '../components/NavBarItem'

let UndoRedo = ({ canUndo, canRedo, onUndo, onRedo }) => (
        <>
        <NavBarItem name="Undo" onClick={onUndo} disabled={!canUndo} icon="Undo">
            Undo
        </NavBarItem>
        <NavBarItem name="Redo" onClick={onRedo} disabled={!canRedo} icon="Redo">
            Redo
        </NavBarItem>
        </>

)

const mapStateToProps = (state) => ({
    canUndo: state.buttonActions.past.length > 0,
    canRedo: state.buttonActions.future.length > 0
})

const mapDispatchToProps = ({
    onUndo: UndoActionCreators.undo,
    onRedo: UndoActionCreators.redo
})

UndoRedo = connect(
    mapStateToProps,
    mapDispatchToProps
)(UndoRedo)

export default UndoRedo
